import {all, call, cancel, put, select, takeEvery,} from 'redux-saga/effects';
import {CHAT_FETCH_MESSAGES_PAGE, CHAT_PREPARE_CHANNEL_TO_PUSH} from '@src/_redux/chats/constants';
import {IChatChannelModel} from '@src/@interfaces/models/Chat/IChatChannelModel';
import {enrichChatChannel, setChatChannelOrderNumber, thisErrorIsExpired} from '@views/chat/components/api';
import {IReduxChatsState, IReduxRootState} from '@src/@interfaces';
import {
    chatSetChannels,
    chatSetError,
    chatSetMessagesPage,
    chatSetNowLoadingMessagesPage
} from '@src/_redux/chats/actions';
import app from '@src/helpers/app';
import {IListPaginationHttpResponse} from '@src/@interfaces/components/List/IListPaginationHttpResponse';
import {ICommentModel} from '@src/@interfaces/models/Comment/ICommentModel';

export function* channelsOrderNumberSaga() {
    yield takeEvery(CHAT_PREPARE_CHANNEL_TO_PUSH, function* (action: {
        type: string,
        payload: { channel: IChatChannelModel }
    }) {
        const state: IReduxChatsState = yield select((state: IReduxRootState) => state.chats);

        let channels = state.channels.slice();
        const channel: IChatChannelModel = action.payload.channel;
        const index = channels.findIndex(item => item.id === channel.id);

        if (index !== -1) {
            channels[index] = yield call(enrichChatChannel, channel, index);
        } else {
            const effects = [];
            channels = channels.map(item => {
                const newNumber = item.order_number + 1;
                effects.push(
                    call(setChatChannelOrderNumber, item, newNumber)
                );

                return {...item, order_number: newNumber};
            });

            effects.push(
                call(setChatChannelOrderNumber, channel, 0)
            );

            yield all(effects);

            channels.push(
                yield call(enrichChatChannel, channel, 0)
            );

            yield put(chatSetChannels(channels));
        }
    });
}

export function* fetchMessagesPageSaga() {
    yield takeEvery(CHAT_FETCH_MESSAGES_PAGE, function* (action: {
        type: string,
        payload: {
            chatUUID: string,
            page: number,
        },
    }) {
        const {chatUUID, page} = action.payload;
        const chatError: IReduxChatsState['error'] = yield select((state: IReduxRootState) => {
            return state.chats.error;
        });
        const chat: IReduxChatsState['chats'][number] = yield select((state: IReduxRootState) => {
            return state.chats.chats.find(item => item.uuid === chatUUID);
        });
        const chatPage = chat?.messages.pages[page];

        if (
            !chat ||
            chatPage?.isFetching === true ||
            chatPage?.loaded === true ||
            !thisErrorIsExpired(chatError, false) ||
            !thisErrorIsExpired(chat.error, false)
        ) {
            yield cancel();

            return;
        }

        yield put(chatSetNowLoadingMessagesPage(chatUUID, page));

        try {
            const response: IListPaginationHttpResponse<ICommentModel> = yield call(() => {
                return app('http').route('comments.index', {}, {
                    json: {
                        'controller-name': 'Comments',
                        commentable_id: chat.entity?.commentable_id ?? chat.channelId,
                        commentable_type: chat.entity?.commentable_type ?? 'App\\Models\\ChatChannel',
                        page,
                    }
                });
            });

            yield put(chatSetMessagesPage(chatUUID, page, response.data));
        } catch (error) {
            yield call(() => app('errorHandler').report(error as Error));

            yield put(chatSetError(error as Error, chatUUID));
        }
    });
}

export function* chatSagas() {
    yield all([
        channelsOrderNumberSaga(),
        fetchMessagesPageSaga(),
    ]);
}
